var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#546EDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41395 4.26872L10.6021 6.78836C10.6352 6.85847 10.684 6.91911 10.7445 6.96506C10.8049 7.01102 10.8751 7.0409 10.949 7.05213L13.6055 7.45624C13.6906 7.46917 13.7705 7.50678 13.8363 7.56479C13.902 7.62281 13.9509 7.69892 13.9775 7.78452C14.004 7.87012 14.0072 7.96179 13.9865 8.04917C13.9659 8.13654 13.9223 8.21612 13.8607 8.27892L11.9382 10.2401C11.8295 10.351 11.7802 10.5107 11.8055 10.6669L12.2593 13.4363C12.2738 13.525 12.2643 13.6162 12.2319 13.6995C12.1995 13.7829 12.1455 13.8551 12.076 13.9079C12.0064 13.9608 11.9241 13.9923 11.8384 13.9987C11.7527 14.0052 11.6669 13.9865 11.5908 13.9446L9.21446 12.6368C9.1483 12.6005 9.07471 12.5815 9 12.5815C8.92529 12.5815 8.8517 12.6005 8.78554 12.6368L6.40919 13.9446C6.33311 13.9865 6.24735 14.0052 6.16161 13.9987C6.07587 13.9923 5.99358 13.9608 5.92403 13.9079C5.85448 13.8551 5.80045 13.7829 5.76806 13.6995C5.73566 13.6162 5.72618 13.525 5.7407 13.4363L6.1945 10.6669C6.20713 10.5898 6.20166 10.5107 6.17854 10.4364C6.15542 10.362 6.11536 10.2947 6.06182 10.2401L4.13927 8.27892C4.07767 8.21612 4.03409 8.13654 4.01346 8.04917C3.99283 7.96179 3.99597 7.87012 4.02253 7.78452C4.04908 7.69892 4.098 7.62281 4.16373 7.56479C4.22947 7.50678 4.30941 7.46917 4.3945 7.45624L7.05096 7.05213C7.12488 7.0409 7.19509 7.01102 7.25552 6.96506C7.31596 6.91911 7.36481 6.85847 7.39788 6.78836L8.58605 4.26872C8.75651 3.91043 9.24487 3.91043 9.41395 4.26872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot1);
export default __webpack_public_path__ + "static/media/bot1.8b44b9ad2a606099054829425945dc80.svg";
export { ForwardRef as ReactComponent };